import { SORTING_MACHINE as type } from '../actions/types';

const initialState = {
    sortingWarehousesLoading: false,
    sortingWarehousesError: false,
    sortingWarehouses: [],

    sortingMachinesLoading: false,
    sortingMachinesError: false,
    sortingMachines: [],

    allRoutesLoading: false,
    allRoutesError: false,
    allRoutes: [],

    routesUpdate: [],

    sortingConfigsLoading: false,
    sortingConfigsError: false,
    sortingConfigs: [],

    searchItems: {},

    preset: {},

    machineSlots: [],
    machineSlotsLoading: false,
    machineSlotsError: false,

    configId: '',
    isActive: false
}

export default function sortingMachineManagementReducer(state = initialState, action) {
    switch (action.type) {
        case type.GET_MACHINE_SLOTS:
            return {
                ...state,
                machineSlotsLoading: true
            }
        case type.GET_MACHINE_SLOTS_SUCCESS:
            return {
                ...state,
                machineSlots: action.payload,
                machineSlotsLoading: false
            }
        case type.GET_MACHINE_SLOTS_FAIL:
            return {
                ...state,
                machineSlotsError: action.payload,
                machineSlotsLoading: false,
                machineSlots: initialState.machineSlots
            }
        case type.GET_SORTING_WAREHOUSES:
            return {
                ...state,
                sortingWarehousesLoading: true
            }
        case type.GET_SORTING_WAREHOUSES_SUCCESS:
            return {
                ...state,
                sortingWarehouses: action.payload,
                sortingWarehousesLoading: false
            }
        case type.GET_SORTING_WAREHOUSES_FAIL:
            return {
                ...state,
                sortingWarehousesError: action.payload,
                sortingWarehousesLoading: false,
                sortingWarehouses: initialState.sortingWarehouses
            }
        case type.GET_SORTING_MACHINES:
            return {
                ...state,
                sortingMachinesLoading: true
            }
        case type.GET_SORTING_MACHINES_SUCCESS:
            return {
                ...state,
                sortingMachinesLoading: false,
                sortingMachines: action.payload
            }
        case type.GET_SORTING_MACHINES_FAIL:
            return {
                ...state,
                sortingMachinesLoading: false,
                sortingMachinesError: action.payload,
                sortingMachines: initialState.sortingMachines
            }
        case type.GET_ALL_ROUTES:
            return {
                ...state,
                allRoutesLoading: true
            }
        case type.GET_ALL_ROUTES_SUCCESS:
            return {
                ...state,
                allRoutesLoading: false,
                allRoutes: action.payload
            }
        case type.GET_ALL_ROUTES_FAIL:
            return {
                ...state,
                allRoutesLoading: false,
                allRoutesError: action.payload,
                allRoutes: initialState.allRoutes
            }
        case type.HANDLE_ROUTES_UPDATE:
            return {
                ...state,
                routesUpdate: action.payload
            }
        case type.HANDLE_SEARCH_ITEMS:
            return {
                ...state,
                searchItems: action.payload
            }
        case type.HANDLE_PRESET:
            return {
                ...state,
                preset: action.payload
            }
        case type.HANDLE_CURRENT_CONFIG:
            console.log(action.payload)
            return {
                ...state,
                configId: action.payload?.configId,
                isActive: action.payload?.isActive
            }
        case type.QUERY_SORTING_CONFIGS:
            return {
                ...state,
                sortingConfigsLoading: true
            }
        case type.QUERY_SORTING_CONFIGS_SUCCESS:
            return {
                ...state,
                sortingConfigsLoading: false,
                sortingConfigs: action.payload
            }
        case type.QUERY_SORTING_CONFIGS_FAIL:
            return {
                ...state,
                sortingConfigsLoading: false,
                sortingConfigsError: action.payload,
                sortingConfigs: initialState.sortingConfigs
            }
        default:
            return state;
    }
}